import { array, boolean } from 'yup';
import { contactSchema } from '../../shared';

export function useContactsSchema() {
    return array()
        .of(contactSchema().shape({ primaryContact: boolean().required() }))
        .required();
}
